/* eslint-disable react/jsx-no-target-blank */
import useUrl from 'hooks/useUrl';
import React from 'react';
import { ImagePreview } from 'react-vant';

type AttachmentProps = {
  item: {
    url: string;
    name: string;
  };
  width?: string;
  height?: string;
};
export default function ProfileAttachment({ item, width = '145px', height }: AttachmentProps) {
  const { url, name } = item || {};
  const { getPublicUrl } = useUrl();
  function canPreview() {
    if (name) {
      const index = name.lastIndexOf('.');
      const suffix = name.substr(index + 1);
      return suffix === 'png' || suffix === 'jpg' || suffix === 'jpeg';
    }
    return false;
  }

  function PreviewImg() {
    ImagePreview.open({
      images: [getPublicUrl(url)],
      // 开启懒加载
      lazyload: true,
    });
  }

  return (
    <>
      {canPreview() ? (
        <div className="view-btn" onClick={PreviewImg}>
          点击查看
        </div>
      ) : (
        <a href={getPublicUrl(url)} target="_blank">
          {name}
        </a>
      )}
      <style jsx>{`
        .view-btn {
          color: var(--primaryColor);
        }
        .img-wrap {
          position: relative;
        }
        .img-mask {
          position: absolute;
          inset: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          background: rgba(0, 0, 0, 0.5);
          cursor: pointer;
          opacity: 0;
          transition: opacity 0.3s;
          cursor: pointer;
        }
        .img-mask:hover {
          opacity: 1;
        }
        .img-mask-info {
          padding: 0 4px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .anticon-eye {
          display: inline-block;
          color: inherit;
          font-style: normal;
          line-height: 0;
          text-align: center;
          text-transform: none;
          vertical-align: -0.125em;
          text-rendering: optimizeLegibility;
          margin-inline-end: 4px;
        }
      `}</style>
    </>
  );
}
